<template>
	<div class="ma-0 pa-0 dept-table-root pb-1">
		<v-data-table
		:headers="headers"
		dense
		fixed-header
		:items="visibleDepts"		   
		class="elevation-1 dept-table"
		disable-pagination
		hide-default-footer
		height="100%"
		width="100%"				
		item-key="id"
		v-model="selectedDept"
		>
			<template v-slot:item.code="{ item }">
				<v-container  class="pt-4">
				<v-row>
					<v-col class="px-0">
						<template v-for="n in item.level-1" >&#12288;</template>
					</v-col>
					<v-col class="mr-0">
						<v-icon v-if="canOpen(item)" v-on:click="openDept(item)">mdi-plus-box-outline</v-icon>
						<v-icon v-else-if="canClose(item)"  v-on:click="closeDept(item)">mdi-minus-box-outline</v-icon>
						<v-icon v-else>mdi-border-none-variant</v-icon>
					</v-col>
					<v-col class="pl-0 pr-1 mx-0">
						<v-icon v-if="item.selectState==1" v-on:click.stop.prevent="doUnSelectDept(item)">mdi-checkbox-marked</v-icon>
						<v-icon v-else-if="item.selectState==-1" v-on:click.stop.prevent="doSelectDept(item)">mdi-checkbox-blank-outline</v-icon>
						<v-icon v-else v-on:click.stop.prevent="doSelectDept(item)">mdi-checkbox-intermediate</v-icon>						
					</v-col >
					<v-col class="px-0 code-item">
						{{ item.code}}
					</v-col>					
				</v-row>
				</v-container>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import {default as AppApi} from "../../../../api/smp/sys/AppApi.js";
	import {default as DepartmentApi} from "../../../../api/smp/org/DepartmentApi.js";
	import {default as AuthManageApi} from "../../../../api/smp/sys/AuthManageApi.js";
	
	export default {
		name: 'DeptAuthTable',
		components: {
		},
		data: () => ({
			headers:[
				{text: '编号',align: 'start',sortable: false,value: 'code',width:400,divider:true},
				{ text: '名称', value: 'name',sortable: false ,width:200},
				{ text: '状态', value: 'statusName',sortable: false ,width:100},
				{ text: '末级部门', value: 'isLeaf',sortable: false ,width:100},
				{ text: '默认部门', value: 'isDefault',sortable: false ,width:100}
				
			],
			depts:[],			
			visibleDepts:[],
			selectedDept:[],  //部门权限全部只保存较高级（子元素全选就只保存该父元素）
			editing:false,
			deptMap:new Map(),
		}),
		methods:{
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			getSelectedDepts(){
				let me = this;
				let selected = [];
				this.depts.forEach(function(item){
					me.collectSelected(selected,item);
				});
				return selected;
			},
			collectSelected(selected,dept){
				let me = this;
				if(dept.selectState==1)
					selected.push(dept);
				if(dept.lower){
					dept.lower.forEach(function(item){
						me.collectSelected(selected,item);
					});
				}
			},
			setEditing(editing){
				this.editing = editing;
			},
			async loadDepts(){
				let me = this;

				let resp = await DepartmentApi.queryAllDepartmentTree();
								
				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取部门信息失败':msg;
					throw new Error(msg);
					return;
				}
				let departments = data.data.departments;	
				
				//departments = me.genTree(departments);		
				me.customDepts(departments);
				
				me.levelDepts(departments,1,null);													
				
				me.depts = departments;
				me.collectVisibleDepts();
				
			},
			async loadOperGroupPriviledgeDept(operGroupId){
				let me = this;
				return ;

				let resp = await AuthManageApi.queryOperGroupPriviledgeDept(operGroupId);

				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取部门权限信息失败':msg;
					throw new Error(msg);
					return;
				}
				
				let depts = data.data.previledgeDepts;					
				depts.forEach(function(item){
					let dept = me.deptMap.get(item.code);
					if(dept)
						me.selectDeptState(dept,1,true,true);
				});
				
			},
			
			async loadOperPriviledgeDept(operId){
				let me = this;
				
				let resp = await AuthManageApi.queryOperPriviledgeDept(operId);
			
				let data = resp.data;
				if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
					let msg=data.msg;
					msg = ((!msg)||(msg==''))?'获取部门权限信息失败':msg;
					throw new Error(msg);
					return;
				}
				
				let depts = data.data.previledgeDepts;					
				depts.forEach(function(item){
					let dept = me.deptMap.get(item.code);
					if(dept)
						me.selectDeptState(dept,1,true,true);
				});
				
			},
			
			customDepts(depts){
				let me =this;
				depts.forEach(function(item){
					
					item.selectState=-1;
					
					if(item && item.leafFlag && (item.leafFlag==1))
						item.isLeaf = '是';
					else
						item.isLeaf = '否';	
					if(item.lower){
						me.customDepts(item.lower)
					}					
				});
				
			},
			doSelectDept(dept){
				if(!this.editing)
					return;
				if(dept){
					if(dept.lower){
						this.selectLowerDeptState(dept,1,true,false);
					}
					this.selectDeptState(dept,1,false,true);
				}
			},
			doUnSelectDept(dept){
				if(!this.editing)
					return;
				if(dept){
					if(dept.lower){
						this.selectLowerDeptState(dept,-1,true,false);
					}
					this.selectDeptState(dept,-1,false,true);
				}
			},
		
			selectLowerDeptState(dept,state,cascadeChildren,needCheckParentState){
				let me = this;
				if((state!=1)&&(state!=-1)){
					throw new Error('parameter state must in (1,-1)');
					return;
				}
				//先选中所有子节点
				if(dept.lower){
					dept.lower.forEach(function(item){
						item.selectState = state;
						me.selectDeptState(item,state,cascadeChildren,needCheckParentState);
					});
				}
			},
			selectDeptState(dept,state,cascadeChildren,needCheckParentState){
				if((state!=1)&&(state!=-1)){
					throw new Error('parameter state must in (1,-1)');
					return;
				}
					
				if(cascadeChildren==true){
					this.selectLowerDeptState(dept,state,cascadeChildren,needCheckParentState);
				}
				dept.selectState = state;
				if(needCheckParentState){
					this.selectCheckParentNode(dept,needCheckParentState);
				}
			},
			selectCheckParentNode(dept,cascadeParent){
				let me =this;
				let parentDept = this.getParentDept(dept);
				if(parentDept){
					if(this.getChildrenAllSelectedState(parentDept)==1)
						parentDept.selectState = 1;
					else if(this.getChildrenAllSelectedState(parentDept)==-1)	
						parentDept.selectState = -1;
					else
						parentDept.selectState = 0;
					if(cascadeParent)	
						me.selectCheckParentNode(parentDept,cascadeParent);
				}
			},
			//0部分选择 1 全部选择 -1全部未选
			getChildrenAllSelectedState(dept){
				let foundSelected = false;
				let foundUnSelected = false;
				let foundSomeSelected = false;
				dept.lower.forEach(function(item){
					if((item.selectState)&&(item.selectState==1))
						foundSelected = true;
					else if((item.selectState)&&(item.selectState==-1))
						foundUnSelected = true;
					else
						foundSomeSelected = true;
						
				});
				if(((foundSelected==true)&&(foundUnSelected==true))||(foundSomeSelected==true))
					return 0;
				else if(foundSelected)
					return 1;
				return -1;	
			},
			getParentDept(dept){
				let lenPerLevel=5;
				let parentDeptCode = dept.code.substr(0,dept.code.length-1*lenPerLevel);
				return this.deptMap.get(parentDeptCode);				
			},
			levelDepts(depts,level,higherDept){
				let me = this;
				
				depts.forEach(function(item){
					me.depts.push(item);
					item.higher = higherDept;
					item.level = level;
					item.opened = false;		
					if(item.lower)
						me.levelDepts(item.lower,level+1,item);		
					me.deptMap.set(item.code,item);	
				});
			},
			
			canOpen(dept){
				return this.hasLower(dept)&&(!dept.opened);
			},
			canClose(dept){
				return this.hasLower(dept)&&(dept.opened);
			},
			hasLower(dept){
				return dept && dept.lower && dept.lower.length && dept.lower.length>0 ;
			},
			openDept(dept){
				dept.opened = true;
				this.collectVisibleDepts();
			},
			closeDept(dept){
				dept.opened = false;
				this.collectVisibleDepts();
			}, 
			deptVisible(dept){
				if(!dept.higher)
					return true;
				return dept.higher.opened;	
			},
			collectVisibleDept(visible,dept){
				let me = this;
				if(me.deptVisible(dept)){
					visible.push(dept);
					if(dept.lower){
						dept.lower.forEach(function(item){
							me.collectVisibleDept(visible,item);
						});
					}
				}
			},
			collectVisibleDepts(){
				let visible = [];
				let me = this;

				me.depts.forEach(function(item){
					me.collectVisibleDept(visible,item);
				});			

				me.visibleDepts=visible;
			},
		},
		computed:{	
			
		},		
		created(){
		}
	}
</script>

<style scoped>
	.dept-table-root{
		
	}
	.dept-table{
		height:100%;
	}
	.code-item{
		flex-grow: 100;
	}
</style>
